import Vue from "vue";
import Router from "vue-router";

// Rutas principales
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Inicio from './views/Inicio.vue';

// Lazy loadging routes
const Contacto = () => import('./views/Contacto.vue')
const Nosotros = () => import('./views/Nosotros.vue')
const Galeria2  = () => import('./views/Galeria2.vue')
const Productos = () => import('./views/Productos.vue')
const Cajas = () => import('./views/Cajas.vue')
const Rafias = () => import('./views/Rafias.vue')
const Esquineros = () => import('./views/Esquineros.vue')
const Bolsa = () => import('./views/Bolsa.vue')

/* import Contacto from './views/Contacto.vue';
import Nosotros from './views/Nosotros.vue';
import Galeria from './views/Galeria.vue';
import Productos from './views/Productos.vue';
import Cajas from './views/Cajas.vue';
import Rafias from './views/Rafias.vue';
import Esquineros from './views/Esquineros.vue';
import Bolsa from './views/Bolsa.vue'; 
import Galeria2 from './views/Galeria2.vue';
*/

Vue.use(Router);


const router = new Router({
  linkExactActiveClass: "active",
  mode:"history",
  routes: [
    {
      path: "/",
      name: "inicio",
      components: {
        header: AppHeader,
        default: Inicio,
        footer: AppFooter
      }
    },
    {
      path: "/contacto",
      name: "contacto",
      components: {
        header: AppHeader,
        default: Contacto,
        footer: AppFooter
      }
    },
    {
      path: "/nosotros",
      name: "nosotros",
      components: {
        header: AppHeader,
        default: Nosotros,
        footer: AppFooter
      }
    },
    {
      path: "/bolsa",
      name: "bolsa",
      components: {
        header: AppHeader,
        default: Bolsa,
        footer: AppFooter
      }
    },
    {
      path: "/galeria",
      name: "galeria",
      components: {
        header: AppHeader,
        default: Galeria2,
        footer: AppFooter
      }
    },
    {
      path: "/productos",
      name: "productos",
      components: {
        header: AppHeader,
        default:Productos,
        footer: AppFooter
      }
    },
    {
      path: "/rafias",
      name: "rafias",
      components: {
        header: AppHeader,
        default: Rafias,
        footer: AppFooter
      }
    },
    {
      path: "/esquineros",
      name: "esquineros",
      components: {
        header: AppHeader,
        default: Esquineros,
        footer: AppFooter
      }
    },
    {
      path: "/cajas",
      name: "cajas",
      components: {
        header: AppHeader,
        default: Cajas,
        footer: AppFooter
      }
    },
    {
      path: "/horario",
      redirect: "/contacto",
    },
    {
      path:"/ubicaciones",
      redirect:"/contacto#ubicaciones"
    },
    {
      path: "/*",
      redirect: "/",
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeResolve((to,from,next) => {
  document.body.classList.remove('modal-open')
  next()
})

export default router